import { Navigation } from "../../components/navigation/Navigation";
import Footer from "../../shared/footer/Footer";
import "./SearchResult.css";

export function SearchResult() {
  return (
    <div>
      <Navigation />

      <div style={{ height: "120px" }}></div>

      <div className="filters">
        <div className="item">
          <div className="sub-item">
            <img width={"24px"} src="/assets/icons/calendar-color.png" alt="" />
            Fecha
          </div>
          <div className="sub-item">
            <img width={"24px"} src="/assets/icons/time.png" alt="" />
            Hora
          </div>
          <div className="sub-item">
            <img width={"24px"} src="/assets/icons/user.png" alt="" />
            Pers.
          </div>
        </div>

        <div className="item">
          <img width={"24px"} src="/assets/icons/filter.png" alt="" />
          Todos los filtros
          <div className="counts">
            01
          </div>
        </div>

        <div className="item">
          <div className="circle-dark">
            <img width={"18px"} src="/assets/icons/offer.png" alt="" />
          </div>
          Ofertas especiales
        </div>

        <div className="item">
          <div className="circle-dark">
            <img width={"18px"} src="/assets/icons/calendar2-black.png" alt="" />
          </div>
          Citas hoy
        </div>

        <div className="item">
          <div className="circle-dark">
            <img width={"18px"} src="/assets/icons/star.png" alt="" />
          </div>
          Mejor valoradas
        </div>

        <div className="item">
          <img width={"24px"} src="/assets/icons/right.png" alt="" />
        </div>
      </div>

      <div className="container">
        <div className="banner" style={{ background: "#f4e200" }}>

        </div>

      </div>

      <div className="container">
        <div className="row">
        <div className="col-md-7">
          <p>
            ¿Por que has recibido estos resultados?
          </p>
          <div className="number-result">
            100 resultados
          </div>
          <select name="" id="">
            <option value="">Ordenar por</option>
            <option value="">Más recientes</option>
            <option value="">Menos recientes</option>
            <option value="">Más populares</option>
            <option value="">Menos populares</option>
            <option value="">Más baratos</option>
            <option value="">Más caros</option>
          </select>
        </div>
        <div className="col-md-5">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31414.157851370306!2d-64.70772408837504!3d10.199346042281789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2d736754808be5%3A0x2fe867b57d7d6659!2zTGVjaGVyw61hLCBBbnpvw6F0ZWd1aQ!5e0!3m2!1ses-419!2sve!4v1738815506458!5m2!1ses-419!2sve"
            width={"100%"}
            height={850}
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />

        </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}